import Image from 'next/image';
import React from 'react';
import cn from 'classnames';
import Skeleton from 'react-loading-skeleton';

import { useGetBreakPoints } from '../../../constants/media';

import styles from './MediaInquire.module.scss';

const MediaInquire = ({ data }) => {
  const { isDesktop } = useGetBreakPoints();
  const [isImageLoaded, setIsImageLoaded] = React.useState(false);

  return (
    <div
      className={'wrapper section'}
      data-testid='media-inquire'
      itemScope
      itemType='https://schema.org/Article'
    >
      <div
        className={cn(styles.infoBlock, {
          [styles.reverse]: data.reverse,
        })}
      >
        <div className={styles.info}>
          {isDesktop && <div className={styles.title}>{data?.title}</div>}
          <div dangerouslySetInnerHTML={{ __html: data?.description }} />
        </div>
        <div className={styles.image}>
          {!isDesktop && <div className={styles.title}>{data?.title}</div>}
          <div className={styles.imageWrapper}>
            {!isImageLoaded && (
              <Skeleton width={670} height={500} className={styles.skeleton} />
            )}
            <Image
              src={data?.image}
              width={670}
              height={500}
              alt={data?.title}
              title={data?.title}
              data-testid='mocked-image'
              className={styles.mainImage}
              onLoadingComplete={() => setIsImageLoaded(true)}
              style={{
                visibility: isImageLoaded ? 'visible' : 'hidden',
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default MediaInquire;
